var _class, _descriptor, _DPopover;
function _initializerDefineProperty(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object.keys(descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;
  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }
  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);
  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }
  if (desc.initializer === void 0) {
    Object.defineProperty(target, property, desc);
    desc = null;
  }
  return desc;
}
function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.');
}
import Component from "@glimmer/component";
import { service } from "@ember/service";
import { modifier } from "ember-modifier";
import deprecated from "discourse-common/lib/deprecated";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
let DPopover = (_class = (_DPopover = class DPopover extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "tooltip", _descriptor, this);
    _defineProperty(this, "registerDTooltip", modifier(element1 => {
      deprecated("`<DPopover />` is deprecated. Use `<DTooltip />` or the `tooltip` service instead.", {
        id: "discourse.d-popover"
      });
      const trigger1 = element1.children[0];
      const content1 = element1.children[1];
      if (!trigger1 || !content1) {
        return;
      }
      const instance1 = this.tooltip.register(trigger1, {
        content: content1
      });
      content1.remove();
      return () => {
        instance1.destroy();
      };
    }));
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <div style="display:inline-flex;" {{this.registerDTooltip}}>
      {{yield}}
    </div>
  
*/
{
  "id": "kEXzdHRf",
  "block": "[[[1,\"\\n    \"],[11,0],[24,5,\"display:inline-flex;\"],[4,[30,0,[\"registerDTooltip\"]],null,null],[12],[1,\"\\n      \"],[18,1,null],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[\"&default\"],false,[\"yield\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/float-kit.d0433c99/node_modules/float-kit/components/d-popover.js",
  "isStrictMode": true
}), _DPopover), _DPopover), _descriptor = _applyDecoratedDescriptor(_class.prototype, "tooltip", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { DPopover as default };